var propTypes = {exports: {}};

export { propTypes as p };
